import { Controller } from '@hotwired/stimulus';

// Fenêtre (<dialog> de DialogComponent) : ouverte à
// l'arrivée quand `open` (fenêtre chargée par le serveur), puis plus jamais
// en se rebranchant (page revenue du cache Turbo) ; focus sur le premier
// champ fautif visible (refus du serveur), sinon le premier champ visible ;
// Échap (natif) ou Annuler ferment ; fermée quand la page
// est quittée (cache Turbo, cache de navigation du navigateur). `closable`
// faux : Échap refusé, rouverte si le navigateur la ferme quand même.
export default class extends Controller {
    static values = { open: Boolean, closable: { type: Boolean, default: true } };

    connect() {
        this.closeNow = () => {
            this.leaving = true;
            this.close();
        };
        this.refuse = (event) => {
            if (!this.closableValue) event.preventDefault();
        };
        this.reopen = () => {
            if (!this.closableValue && !this.leaving && this.element.isConnected) this.element.showModal();
        };
        this.element.addEventListener('cancel', this.refuse);
        this.element.addEventListener('close', this.reopen);
        document.addEventListener('turbo:before-cache', this.closeNow);
        window.addEventListener('pagehide', this.closeNow);
        if (!this.openValue) return;
        this.openValue = false;
        this.open();
    }

    disconnect() {
        this.element.removeEventListener('cancel', this.refuse);
        this.element.removeEventListener('close', this.reopen);
        document.removeEventListener('turbo:before-cache', this.closeNow);
        window.removeEventListener('pagehide', this.closeNow);
    }

    open() {
        if (!this.element.open) this.element.showModal();
        // Après le branchement des listes (combobox : saisie visible, select masqué).
        requestAnimationFrame(() => {
            const fields = [...this.element.querySelectorAll('input:not([type=hidden]), select, textarea')].filter((field) => field.checkVisibility());
            (fields.find((field) => field.getAttribute('aria-invalid') === 'true') || fields[0])?.focus();
        });
    }

    close() {
        if (this.element.open) this.element.close();
    }
}
